import { readCache, writeCache } from './cache';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

async function request(path, options = {}) {
  const url = `${API_BASE_URL}${path}`;
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  return response.json();
}

export function get(path, options = {}) {
  return request(path, { ...options, method: 'GET' });
}

const STORY_FEED_PATH = '/pf/api/v3/content/fetch/story-feed-query';
const WEBSITE = 'irishtimes';

// Fetches stories from the CMS story-feed-query API. `query` is a Lucene
// query string (see buildSectionsQuery in cmsSections.js); the API expects
// it JSON-encoded together with the page size in a single `query` param.
// Responses are cached locally (see cache.js) unless caching is disabled.
export async function fetchStoryFeed({ query, size = 10 }) {
  const params = new URLSearchParams({
    query: JSON.stringify({ size, query }),
    _website: WEBSITE,
  });
  const path = `${STORY_FEED_PATH}?${params}`;

  const cached = readCache(path);
  if (cached) return cached;

  const data = await get(path);
  writeCache(path, data);
  return data;
}

export function post(path, body, options = {}) {
  return request(path, {
    ...options,
    method: 'POST',
    body: JSON.stringify(body),
  });
}
